import UpdateCURPError from './UpdateCURPError';
class InvestorNotHasAnCURPRegistered extends UpdateCURPError {
    constructor() {
        super('Investor does not has any CURP registered');
    }
}
export default InvestorNotHasAnCURPRegistered;
